/*eslint-disable*/export const messages=JSON.parse("{\"icon.title.warning\":[\"Varseltrekant med utropstegn\"]}");